export interface CreateAccountResponse {
  message: string;
  sac: string;
  telefone: string;
  title: string;
  qrcode_url: string;
  type: string;
}

export const ERROR_TYPES = {
  PHONE_ALREADY_EXISTS: 'phone_already_exists',
  TAX_IDENTIFICATION_ALREADY_EXISTS: 'tax_identification_already_exists',
  EMAIL_ALREADY_EXISTS: 'email_already_exists',
} as const;
